<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="星级打分"
    width="420px"
    :close-on-click-modal="false"
    @closed="resetHover"
  >
    <div class="rating-wrap">
      <i
        v-for="star in 5"
        :key="star"
        :class="star <= displayScore ? 'el-icon-star-on active-star' : 'el-icon-star-off empty-star'"
        @mouseenter="hoverScore = star"
        @mouseleave="hoverScore = 0"
        @click="currentScore = star"
      />
    </div>
    <div slot="footer">
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RatingDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      currentScore: 0,
      hoverScore: 0
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    displayScore () {
      return this.hoverScore || this.currentScore
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (val) {
          this.currentScore = this.value || 0
        }
      }
    },
    value (val) {
      this.currentScore = val || 0
    }
  },
  methods: {
    handleConfirm () {
      this.$emit('confirm', this.currentScore)
    },
    resetHover () {
      this.hoverScore = 0
    }
  }
}
</script>

<style lang="stylus" scoped>
.rating-wrap
  display flex
  justify-content center
  padding 20px 0 10px

.active-star,
.empty-star
  font-size 30px
  margin 0 8px
  cursor pointer
  transition color .2s ease

.active-star
  color #F7BA2A

.empty-star
  color #C0C4CC
</style>
